<template>
  <div class="popup z-index-10-fg confirmation small-popup quote-product-import-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Import Quote Products</h2>
        <img src="../../assets/close.svg" alt="" class="popup-close" @click="$emit('close')" />
      </div>

      <div class="popup-body">
        <Dropdown label="Pricing Structure" :options="priceListOptions" v-model="priceListId" :invalid="showErrors && !priceListId" />
        <label class="file-picker">
          <span>{{ fileName || 'Choose Excel file (.xlsx)' }}</span>
          <input type="file" accept=".xlsx" @change="handleFileSelect" />
        </label>
        <p class="note">Rows without a New Part # will be skipped. Existing products are updated by Part #.</p>
      </div>

      <div class="popup-footer">
        <button @click="$emit('close')" class="text-btn">cancel</button>
        <button :disabled="isImporting" :class="{ 'square-btn': true, saving: isImporting }" @click="importFile()">Import<img src="../../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import Dropdown from '@/components/inputs/Dropdown.vue';
import useQuoteProductImport from '@/composables/useQuoteProductImport';
import useAlerts from '@/composables/useAlerts';

export default {
  name: 'QuoteProductImportPopup',
  components: { Dropdown },
  emits: ['close', 'imported'],
  props: {
    priceLists: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { importQuoteProducts } = useQuoteProductImport();
    const { addAlert } = useAlerts();

    return { importQuoteProducts, addAlert };
  },
  data() {
    return {
      priceListId: '',
      file: null,
      isImporting: false,
      showErrors: false,
    };
  },
  computed: {
    priceListOptions() {
      return this.priceLists.map((priceList) => ({ text: priceList.NAME, value: priceList.PICKLISTITEMID }));
    },
    fileName() {
      return this.file?.name || '';
    },
  },
  methods: {
    handleFileSelect(event) {
      this.file = event.target.files?.[0] || null;
    },
    async importFile() {
      this.showErrors = true;

      if (!this.priceListId) {
        this.addAlert('Pricing structure is required', 'high', 3);
        return;
      }

      if (!this.file) {
        this.addAlert('Excel file is required', 'high', 3);
        return;
      }

      if (!this.file.name.toLowerCase().endsWith('.xlsx')) {
        this.addAlert('Only .xlsx files are supported', 'high', 3);
        return;
      }

      this.isImporting = true;
      const result = await this.importQuoteProducts(this.file, this.priceListId);
      this.isImporting = false;

      if (!result) return;

      this.addAlert(`Skipped ${result.skipped} rows without a New Part #`, 'low', 4);
      this.$emit('imported');
    },
  },
  mounted() {
    this.priceListId = this.priceLists[0]?.PICKLISTITEMID || '';
  },
};
</script>

<style lang="scss" scoped>
.quote-product-import-popup {
  width: 28rem;

  .popup-body {
    padding: 1.5rem;
  }

  .file-picker {
    display: block;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px dashed $inputBorderColor;
    border-radius: $borderRadius4;
    cursor: pointer;

    input {
      display: none;
    }
  }

  .note {
    margin: 1rem 0 0;
    font-size: $fontSize13;
  }
}
</style>
